export default __webpack_public_path__ + "static/media/xfinity.15ff5f4b.svg";